import { Button, Col, FormGroup, Row } from "reactstrap";
import PageLayout from "../layout/page";
import { arrowLeft, arrowRight, deleteIcon, file, fileupload } from "../../constant/icons";
import ReactSelect from "react-select";
import { useRef, useState } from "react";
import { BalanceSheetView } from "./balanceSheetView";
import { getSheetData } from "../job/addUpdate/wizardBox/utility";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useSearchParams } from "react-router-dom";
import { useApp } from "../../components/app";
import { useNavigate } from "react-router-dom";


const BalanceSheet = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isViewMode = searchParams.get("tenantId") !== null;
  const [uploadFile, setUploadFile] = useState<any[] | null>(null);
  const [sheetOptions, setSheetOptions] = useState<any[] | null>(null);
  const [selectedSheet, setSelectedSheet] = useState<any | null>(null);
  const [columnOptions, setColumnOptions] = useState<any[] | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const app = useApp();
  const navigate = useNavigate()


  const addFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const sheetList = await getSheetData({ fileUpload: [{ file: files[0] }] });
      if (sheetList && Array.isArray(sheetList) && sheetList[0].totalSheet) {
        const sheets = sheetList[0].totalSheet.map((sheet: any, index: number) => ({
          value: index,
          label: sheet.name || `Sheet ${index + 1}`,
        }));
        setSheetOptions(sheets);
        setUploadFile(sheetList);
      }
    }
  };

  const handleSheetSelect = (option: any) => {
    if (option && uploadFile && uploadFile[0].totalSheet) {
      const sheetIndex = option.value;
      const sheet = uploadFile[0].totalSheet[sheetIndex];
      setSelectedSheet({ index: sheetIndex, data: sheet });

      const columns = sheet.sourceColumnList?.[0]?.map((item: string) => ({ value: item, label: item, })) || [];
      setColumnOptions(columns);
    } else {
      setSelectedSheet(null);
      setColumnOptions(null);
    }
  };

  const handleSubmit = (values: any) => {
    setSearchParams({ tenantId: app.conversation?.tenant?.[0]?.id?.toString() ?? "0" });
  };

  const handleRemoveFile = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation(); // Prevent click event from bubbling up to the label
    // Clear all related states
    setUploadFile(null);
    setSheetOptions(null);
    setSelectedSheet(null);
    setColumnOptions(null);
    // Reset the file input field
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };


  const handleBack = () => { setSearchParams({}); };

  return isViewMode ? (
    <BalanceSheetView
      tenantId={searchParams.get("tenantId") ?? "0"}
      uploadFile={uploadFile}
      selectedSheet={selectedSheet}
      mappings={{
        accountName: formikValues?.accountName?.value,
        accountCode: formikValues?.accountCode?.value,
        amount: formikValues?.amount?.value,
        creditAmount: formikValues?.creditAmount?.value,
        debitAmount: formikValues?.debitAmount?.value,
      }}
      onBack={handleBack}
      mergeData={false}
    />
  ) : (
    <PageLayout
      title={
        <>
          <Button color="link" className="btn-back" onClick={() => { navigate("/") }}>{arrowLeft.icon}
          </Button>Balance Sheet
        </>
      }
      View={
        <>
          <Row>
            <Col lg={12} className="mb-4">
              <div className="dropzone mb-3">
                <label htmlFor="browserfile" className="dropzone-container">
                  <div className="file-icon">{fileupload.icon}</div>
                  <div className="dropzone-title">Drag and drop your files or<span className="browse"> browse</span> your files</div>
                </label>

                {uploadFile && (
                  <div className="attachment-data-list mt-2">
                    <div className="attachment-data">
                      <a title="File" className="file-box">
                        {file.icon}
                        <p>{uploadFile[0]?.file?.name}</p>
                      </a>
                      <a
                        className="remove-box"
                        title="remove"
                        onClick={handleRemoveFile}
                        style={{ cursor: "pointer" }}
                      >
                        {deleteIcon.icon}
                      </a>
                    </div>
                  </div>
                )}

                <input
                  ref={fileInputRef}
                  id="browserfile"
                  name="browserfile"
                  type="file"
                  className="form-control"
                  onChange={addFiles}
                />
              </div>
            </Col>

            {uploadFile && sheetOptions && (
              <Col lg={12} className="mb-4">
                <FormGroup>
                  <label>Select Sheet to Map <span style={{ color: "red" }}>*</span></label>
                  <ReactSelect
                    options={sheetOptions}
                    onChange={handleSheetSelect}
                    placeholder="Select a sheet"
                    isClearable
                    menuPortalTarget={document.body}
                    menuPlacement="auto"
                    menuPosition="fixed"
                  />
                </FormGroup>
              </Col>
            )}

            {selectedSheet && columnOptions && (
              <Formik
                initialValues={{ accountCode: null, date: null, amount: null, creditAmount: null, accountName: null, debitAmount: null, }}
                validationSchema={Yup.object({
                  // accountCode: Yup.object().required("Account Code is required"),
                  // date: Yup.object().required("Date is required"),
                  amount: Yup.object().required("Balance is required"),
                  creditAmount: Yup.object().required("Credit Amount is required"),
                  debitAmount: Yup.object().required("Debit Amount is required"),
                  accountName: Yup.object().required("Account Name is required"),
                })}
                onSubmit={handleSubmit}
              >
                {({ values, errors, touched, setFieldValue }) => {
                  formikValues = values;
                  return (
                    <Form className="w-100">
                      <Col lg={12} className="column-maping-box blance_maping_box">
                        <div className="column-maping-list-data">
                          <ul className="column-header">
                            <li>Destination Column</li>
                            <li>Source Column</li>
                            <li>Remark</li>
                            <li></li>
                          </ul>

                          <div className="column-body small-scroll">
                            {defaultMappingColumns.map(({ label, name }) => (
                              <div className="column-data-list" key={name}>
                                <label>{label}<span>*</span></label>
                                <FormGroup className="form-floating">
                                  <ReactSelect
                                    className={`column_field_select ${errors[name as keyof typeof errors] &&
                                      touched[name as keyof typeof touched]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    name={name}
                                    options={columnOptions || []}
                                    value={values[name as keyof typeof values]}
                                    onChange={(option) => setFieldValue(name, option)}
                                    placeholder="Select column field"
                                    isClearable
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuPosition="fixed"
                                  />
                                  {errors[name as keyof typeof errors] &&
                                    touched[name as keyof typeof touched] && (
                                      <div className="invalid-feedback d-block">
                                        {errors[name as keyof typeof errors]}
                                      </div>
                                    )}
                                </FormGroup>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>

                      <Col lg={12} className="d-flex justify-content-end mt-3">
                        <button className="btn btn-primary" type="submit" title="Next">Next {arrowRight.icon}</button>
                      </Col>
                    </Form>
                  );
                }}
              </Formik>
            )}
          </Row>
        </>
      }
    />
  );
};

let formikValues: any;

export { BalanceSheet };

export const defaultMappingColumns = [
  { label: "Account Name", name: "accountName" },
  // { label: "Account Code", name: "accountCode" },
  // { label: "Date", name: "date" },
  { label: "Balance", name: "amount" },
  { label: "Debit", name: "debitAmount" },
  { label: "Credit", name: "creditAmount" },
]